import { render } from "./paids.vue?vue&type=template&id=341a4bc8"
import script from "./paids.vue?vue&type=script&lang=js"
export * from "./paids.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__